import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

const toNumber = (v: string): number => (v === null ? null : parseInt(v, 10));

export const useRouteId = (): {
    id: number;
    answerId: number;
    mailingId: number;
    pageId: number;
} => {
    const {
        answer_id = null,
        id = null,
        mail_id = null,
        pageId = null,
    } = useParams<{ id?: string; answer_id?: string; mail_id?: string; pageId?: string }>();

    return useMemo(
        () => ({
            id: toNumber(id),
            answerId: toNumber(answer_id),
            mailingId: toNumber(mail_id),
            pageId: toNumber(pageId),
        }),
        [answer_id, id, mail_id, pageId],
    );
};

export const useRouteSmsId = (): {
    id: number;
    answerId: number;
    listId: number;
    pageId: number;
} => {
    const {
        answer_id = null,
        id = null,
        sms_id = null,
        pageId = null,
    } = useParams<{ id?: string; answer_id?: string; sms_id?: string; pageId?: string }>();

    return useMemo(
        () => ({
            id: toNumber(id),
            answerId: toNumber(answer_id),
            listId: toNumber(sms_id),
            pageId: toNumber(pageId),
        }),
        [answer_id, id, sms_id, pageId],
    );
};
